import React from "react";
import { useFetch } from "hooks/api";
import { Row, Col, Table } from "react-bootstrap";
import moment from "moment";
import Loading from "components/core/blocks/Loading";
import { formatCurrency } from "utils/formatNumber";

const BiddingProgramLog = ({ programId, targetId, targetType = "keyword", marketPlace, title }) => {
  const logQueryFilters = {
    [`adv_${targetType}`]: targetId,
  };

  const { data, isLoading } = useFetch(
    ["program_logs", programId, targetId, targetType],
    `/programlogs/advertised_${targetType}s/`,
    logQueryFilters,
    { select: (data) => data?.data?.results ?? [] },
  );
  return (
    <>
      <Row className="pt-5">
        <Col>
          <div className="pb-3">
            <span className="fs-4 fw-bold">{title} Logs</span>
          </div>
        </Col>
      </Row>
      <Row className="pb-3">
        <Col>
          {isLoading && <Loading height={"300px"} fullPage={false} />}
          {!isLoading && (
            <Table striped bordered>
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Program</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((log, i) => {
                  return (
                    <tr key={i}>
                      <td>{moment(log.ts).format("YYYY-MM-DD HH:mm:ss")}</td>
                      <td>
                        {log?.program?.name} ({log?.program?.id})
                      </td>
                      <td>
                        {log?.meta[1]?.function !== undefined ?
                          <div>
                            <span className="fw-bold">{log?.meta[1]?.function}</span>
                            :&nbsp;
                            <span className="fw-light">
                              New: {formatCurrency(log?.meta[1]?.next_bid, marketPlace.marketPlace)}
                            </span>
                            &nbsp; - &nbsp;
                            <span className="fw-light">
                              Prev: {formatCurrency(log?.meta[1]?.current_bid, marketPlace.marketPlace)}
                            </span>
                          </div>
                        : "N/A"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </Col>
      </Row>
    </>
  );
};

export default BiddingProgramLog;
